import React from "react";
import { Form, Button } from "react-bootstrap";
import MapComponent from "./MapComponent";

function ContactPage() {
  return (
    <div>
      {/* Diğer içerikler */}
      <MapComponent />
    </div>
  );
}

export default ContactPage;